import React from "react";
import styled from "../style.module.css";

// Textual breakdown list — extracted unchanged from the original dashboard.
// Optional `note` renders a small footnote under the list (e.g. data caveats).
const ListSection = ({ title, rows, emptyHint, note }) => (
  <div className={styled.listSection}>
    <h3 className={styled.listTitle}>{title}</h3>
    {rows && rows.length > 0 ? (
      <>
        <div className={styled.listRows}>
          {rows.map((r, i) => (
            <div key={i} className={styled.listRow}>
              <span className={styled.listRank}>{i + 1}</span>
              <span className={styled.listLabel}>{r.label}</span>
              {r.sub != null && <span className={styled.listSub}>{r.sub}</span>}
              <span className={styled.listValue}>{r.value}</span>
            </div>
          ))}
        </div>
        {note && <p className={styled.listNote}>{note}</p>}
      </>
    ) : (
      <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
    )}
  </div>
);

export default ListSection;
